import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonComponent } from "@components/button/button.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CertifikatKontraktDto } from "../certifikat-models";

@Component({
    selector: "rask-certifikat-lista-kontrakt-dialog",
    templateUrl: "./certifikat-lista-kontrakt-dialog.component.html",
    styleUrls: ["./certifikat-lista-kontrakt-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        ButtonComponent
    ]
})
export class CertifikatListaKontraktDialogComponent {
    protected kontrakt: CertifikatKontraktDto[] = [];

    private readonly modal = inject(NgbActiveModal);

    get data(): CertifikatKontraktDto[] {
        return this.kontrakt;
    }

    set data(value: CertifikatKontraktDto[]) {
        this.kontrakt = value;
    }

    protected onClose() {
        this.modal.close();
    }
}
